import React from "react";
import { M2Layout, PageHero, SectionIndex, FigCap, CTABand, ProductFigure } from "../../components/machines2/Blocks";
import { Reveal } from "../../components/enterprise2/Reveal";
import { SubNav } from "../../components/enterprise2/SubNav";
import { PRODUCTS } from "../../data/machines2";

export default function Machines2Products() {
  return (
    <M2Layout active="products" title="Products | Crowther for Machines">
      <PageHero
        eyebrow="Products"
        title="Physical AI, owned by the people who run it."
        sub="Machines are bought to work for decades. The intelligence inside them should serve the owner for just as long. Every Crowther product runs where you run, learns from your work, and obeys your keys."
        testId="m2-products-hero"
      />
      <SubNav items={PRODUCTS.map((p) => ({ id: p.key, label: p.name }))} testId="m2-products-subnav" />

      {PRODUCTS.map((p, i) => (
        <Reveal as="section" key={p.key} id={p.key} className="e2-shell e2-section" data-testid={`m2-product-${p.key}`}>
          <SectionIndex n={p.n} label={p.name} />
          <div className="e2-split">
            <div className="e2-split-title-col">
              <h2 className="e2-h-l">{p.heading}</h2>
              <p className="e2-body e2-split-lede">{p.body}</p>
            </div>
            <div>
              <FigCap n={i + 1} label={p.name} />
              <ProductFigure product={p} tone={["forest", "navy", "forest", "navy"][i]} />
            </div>
          </div>
        </Reveal>
      ))}

      <CTABand line="Find out more about Crowther for machines." testId="m2-products-cta" />
    </M2Layout>
  );
}
